import React, { useContext } from 'react';
import { AppDataContext } from '../../../contexts/appData';
import { HistoryContext } from '../../../contexts/history';
import { useMediaQuery, usePreventBodyScroll } from '../../../libs';
import { useCountDown } from '../../../libs/hooks/useCountDown';
import { PromotionPackageServices } from '../../../libs/flashSales';

const FlashSalesModal = ({ callback, data, ...props }) => {
  const { langs, getLang } = useContext(AppDataContext);
  const isMobile = useMediaQuery('(max-width: 768px)');
  const { push } = useContext(HistoryContext);
  usePreventBodyScroll();

  const promPackageSale = data?.promPackageSale;
  const { timeLeft } = useCountDown({ endDate: promPackageSale?.sale_end_date || '' });

  if (!promPackageSale) return null;

  const isExpired = timeLeft.days < 0 || timeLeft.hours < 0 || timeLeft.minutes < 0 || timeLeft.seconds < 0;

  const timeArr = isExpired
    ? ['00', '00', '00', '00']
    : [
        String(timeLeft.days).padStart(2, '0'),
        String(timeLeft.hours).padStart(2, '0'),
        String(timeLeft.minutes).padStart(2, '0'),
        String(timeLeft.seconds).padStart(2, '0'),
      ];

  const onContinue = () => {
    push(`/${getLang}/subscriptions`);
    callback(null, 'onAgree');
    callback(null, 'destroy');
  };

  const promotions = promPackageSale?.package_services?.reduce((acc, item) => {
    const promotion = PromotionPackageServices.find((p) => p.id === item.service.prom_service_id);
    if (promotion) {
      acc.push(promotion);
    }
    return acc;
  }, []);

  return (
    <div
      className="content-scroll"
      style={{
        height: 'fit-content',
        background: 'white',
        maxWidth: isMobile ? '100%' : '80%',
        margin: '0 auto',
        position: 'relative',
        overflow: 'visible',
        paddingBottom: '20px',
        marginBottom: isMobile ? '60px' : 0,
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
      }}
    >
      <div
        style={{
          position: 'absolute',
          left: '50%',
          top: '-60px',
          transform: 'translateX(-50%)',
          zIndex: 20,
          display: 'flex',
        }}
      >
        {promotions?.map((promotion) => (
          <div
            key={promotion?.id}
            style={{
              width: isMobile ? '64px' : '80px',
              height: isMobile ? '64px' : '80px',
              background: promotion?.bgColor,
              borderRadius: '50%',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              boxShadow: `0 1px 14px 0 ${promotion?.bgColor}`,
              border:'2px solid white',
              marginLeft:'-16px'
            }}
          >
            <i className={`svg-i ${promotion?.iconName}`} style={{ width: '48px', height: '48px' }}></i>
          </div>
        ))}
      </div>
      <div className={'font-medium'} style={{ color: '#757B8C', fontSize: '14px', marginTop: '40px' }}>
        {promotions?.map((promotion) => promotion?.name).join(' / ')}
      </div>
      <div className={'font-bold'} style={{ fontSize: '24px', textAlign: 'center' }}>
        {promPackageSale?.lang_data?.title}
      </div>
      <div className={'font-base'} style={{ fontSize: '14px', textAlign: 'center', marginTop: '12px' }}>
        {promPackageSale?.lang_data?.description}
      </div>
      <div
        style={{
          width: '100%',
          background: '#F4F4F5',
          padding: '24px 0',
          marginTop: '24px',
          borderRadius: '16px',
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
        }}
      >
        <div className={'font-base'} style={{ fontSize: '14px', color: '#222' }}>
          შეთავაზების დასრულებამდე დარჩენილია
        </div>
        <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', gap: '8px', marginTop: '16px' }}>
          {timeArr.map((item, index) => (
            <React.Fragment key={index}>
              <div
                style={{
                  background: 'white',
                  width: '45px',
                  height: '47px',
                  display: 'flex',
                  borderRadius: '4px',
                  justifyContent: 'center',
                  alignItems: 'center',
                }}
              >
                <span className={'font-medium'} style={{ fontSize: '20px', color: '#222' }}>
                  {item}
                </span>
              </div>
              {index < timeArr.length - 1 && (
                <span className={'font-medium'} style={{ fontSize: '20px', color: '#222' }}>
                  :
                </span>
              )}
            </React.Fragment>
          ))}
        </div>
      </div>
      <button
        className="btn d-inline-flex align-items-center h-48px border-radius font-size-14 py-15px bg-primary font-medium"
        style={{ color: '#222', transition: 'all 0.3s ease', width: '100%', justifyContent: 'center', marginTop: '40px' }}
        onClick={onContinue}
      >
        გაგრძელება
      </button>
    </div>
  );
};

export default FlashSalesModal;
